module.exports = {

  trouble_shooting_events_tab_title: "Troubleshooting",
  trouble_shooting_events_tab_filter_by_last: "Last",
  trouble_shooting_events_tab_filter_by_date: "Range",
  trouble_shooting_events_tab_apply_filters: "Apply",

  trouble_shooting_events_tab_id: "ID",
  trouble_shooting_events_tab_server_time: "Server Time",
  trouble_shooting_events_tab_unit_time: "Unit Time",

  trouble_shooting_events_tab_data_center: "Data Center",
  trouble_shooting_events_tab_event_code: "Raw Event",
  trouble_shooting_events_tab_event_name: "Event Name",
  trouble_shooting_events_tab_heading: "Heading",
  trouble_shooting_events_tab_latitude: "Latitude",
  trouble_shooting_events_tab_longitude: "Longitude",
  trouble_shooting_events_tab_sequence_number: "Sequence #",
  trouble_shooting_events_tab_speed: "GPS Speed",
  trouble_shooting_events_tab_trail: "Trail",
  trouble_shooting_events_tab_unit_type: "Unit Type",
  trouble_shooting_events_tab_address: "Address",
  trouble_shooting_events_tab_records: "Records",
  trouble_shooting_events_tab_load_error: "Error loading troubleshooting events",
  trouble_shooting_events_tab_date_range: "Please select a valid date range",
  trouble_shooting_events_tab_voltage: "Voltage",
  trouble_shooting_events_tab_raw_message: "Raw Data",

  trouble_shooting_events_tab_maintenance_warnings: "Warnings",
  trouble_shooting_events_tab_events: "Events",
  trouble_shooting_events_tab_user: "User"
}
